
const _BASE_URL = "https://darihati.futnet.id/api/admin/"

export default {
    _BASE_URL
}


// WEBPACK FOOTER //
// ./src/store/constant.js